/**
 * The mirrored Colyseus schema (frontend.md §1.3.1).
 *
 * Every field here is *public* room truth: the same values every seat sees.
 * Nothing private ever lands in this slice — hands live in `table.myHand`,
 * which only ever holds cards the server sent to this client alone.
 *
 * `seats` keeps per-element identity stable so a selector on one seat does not
 * re-render the other three; that is the whole reason §1.2 chose Zustand.
 */

import type { StateCreator } from 'zustand';

import type { RoomSlice, Slices } from './types';

export const createRoomSlice: StateCreator<Slices, [], [], RoomSlice> = (set) => ({
  room: {
    roomId: null,
    connection: 'idle',
    joinError: null,
    code: null,
    phase: 'lobby',
    gamePhase: null,
    lance: null,
    config: null,
    leaderSeat: null,
    seats: [],
    dealer: null,
    mano: null,
    turnSeat: null,
    handNumber: 0,
    musRound: 0,
    stockCount: 0,
    scores: [0, 0],
    gamesWon: [0, 0],
    ranked: true,
    betting: null,
    lances: [],
    declaredPares: [null, null, null, null],
    declaredJuego: [null, null, null, null],
    revealedBySeat: {},
    mySeat: null,
    chat: [],
    unreadChat: 0,
    clockOffset: 0,
    lastError: null,

    reset: () => {
      set((s) => ({
        room: {
          ...s.room,
          roomId: null,
          connection: 'idle',
          joinError: null,
          code: null,
          phase: 'lobby',
          gamePhase: null,
          lance: null,
          config: null,
          leaderSeat: null,
          seats: [],
          dealer: null,
          mano: null,
          turnSeat: null,
          handNumber: 0,
          musRound: 0,
          stockCount: 0,
          scores: [0, 0],
          gamesWon: [0, 0],
          ranked: true,
          betting: null,
          lances: [],
          mySeat: null,
          chat: [],
          unreadChat: 0,
          clockOffset: 0,
          lastError: null,
        },
      }));
    },
  },
});
